import { useEffect } from 'react';
import {
  getUser, INACTIVITE_TIMEOUT_MS, INACTIVITE_PAS_VERIFICATION_MS,
} from '../variables/constants';
import { creerMinuteurInactivite } from '../utils/minuteurInactivite';
import { reauthBus } from '../utils/reauthBus';

/**
 * Branche le verrou d'inactivite sur les gestes du navigateur.
 *
 * Ne rend rien : c'est un cablage. La logique de comptage vit dans
 * `utils/minuteurInactivite`, ou elle se verifie sans navigateur.
 *
 * POURQUOI UN COMPOSANT SEPARE DE ReauthGate. ReauthGate repond a une demande
 * de re-saisie ; celui-ci en emet une. Les melanger aurait donne un composant
 * qui s'ouvre tout seul, et dont on ne peut plus tester les deux moities
 * separement.
 *
 * POURQUOI LES ECOUTEURS SONT PASSIFS ET SUR LA FENETRE. `capture: true` les
 * place avant tout gestionnaire de l'application : un clic absorbe par un bouton
 * compte quand meme comme un geste. `passive: true` interdit a l'ecouteur de
 * bloquer le defilement - un verrou d'inactivite n'a aucune raison de rendre la
 * page moins fluide.
 */
export default function GardeInactivite() {
  useEffect(() => {
    const minuteur = creerMinuteurInactivite({
      delaiMs: INACTIVITE_TIMEOUT_MS,
      surInactivite: () => reauthBus.demander(),
    });

    const signaler = () => minuteur.signalerActivite();

    /* `visibilitychange` ne compte comme geste QUE au retour sur l'onglet.
       Le compter au depart rearmerait le minuteur au moment precis ou l'agent
       quitte son poste - l'inverse de ce qu'on veut. */
    const surVisibilite = () => { if (!document.hidden) signaler(); };

    const GESTES = ['mousedown', 'keydown', 'wheel', 'touchstart'];
    GESTES.forEach((g) => window.addEventListener(g, signaler, { capture: true, passive: true }));
    document.addEventListener('visibilitychange', surVisibilite);

    const tour = setInterval(() => {
      /* PAS DE VERROU SANS SESSION. Sur l'ecran de connexion, personne n'est
         connecte : demander un mot de passe pour reprendre une session qui
         n'existe pas afficherait une fenetre dont on ne peut pas sortir. */
      if (!getUser()) {
        minuteur.signalerActivite();
        return;
      }
      minuteur.verifier();
    }, INACTIVITE_PAS_VERIFICATION_MS);

    return () => {
      clearInterval(tour);
      GESTES.forEach((g) => window.removeEventListener(g, signaler, { capture: true }));
      document.removeEventListener('visibilitychange', surVisibilite);
    };
  }, []);

  return null;
}
